export type SiteMode = "public" | "app"

const PUBLIC_HOSTS = new Set([
  "viridian.gmbh",
  "www.viridian.gmbh",
])

/** Public marketing site vs internal app (hostname-based). */
export function getSiteMode(): SiteMode {
  if (process.env.REACT_APP_FORCE_PUBLIC_SITE === "1") return "public"
  const host = window.location.hostname.toLowerCase()
  if (PUBLIC_HOSTS.has(host)) return "public"
  return "app"
}

export function isPublicSite(): boolean {
  return getSiteMode() === "public"
}
